import React from 'react';
import { ArrowForwardOutlined } from '@material-ui/icons';
import { useSelector, useDispatch } from 'react-redux';
import { Tooltip } from 'antd';
import { userPrivilegesSelector } from '../../../../redux/selector';
import { deleteSharedTemplate } from '../../../../redux/services';
import { toast } from '../../../../redux/action';
import { Card, Button, CardHeader } from '../_CardUI/Card.styled';
import { ArchiveButton } from '../_CardUI/CardActionButtons.styled';
import { StyledLogo } from './TemplateCard.styled';
import { formatTimestampToDate, trimTextIfNeeded } from '../_utils';
import Thumbnail from '../Thumbnail';

const TemplateCard = ({
  template,
  onClick,
  setSharedTemplates,
  setCardsBySearch,
}) => {
  const { isSA } = useSelector(userPrivilegesSelector);
  const dispatch = useDispatch();

  const deleteTemplate = async () => {
    try {
      const templateIDToFilter = template._id;
      await deleteSharedTemplate(template._id);

      dispatch(toast('success', 'Shared Template Deleted.'));
      // this will filter out the deleted template
      if (setSharedTemplates) {
        setSharedTemplates(prevUserTemplates =>
          prevUserTemplates.filter(
            template => template._id != templateIDToFilter
          )
        );
      } else {
        setCardsBySearch(prevUserTemplates =>
          prevUserTemplates.filter(
            template => template._id != templateIDToFilter
          )
        );
      }
    } catch (e) {
      dispatch(
        toast('error', `Error deleting the shared template. ${e.message}`)
      );
    }
  };

  return (
    <Card>
      <Thumbnail html={template.html} />
      <Card.Body>
        <CardHeader>
          <CardHeader.Left>
            <StyledLogo />
          </CardHeader.Left>
          {isSA && (
            <CardHeader.Right>
              ⁂
              <Tooltip title="Delete">
                <ArchiveButton onClick={deleteTemplate} />
              </Tooltip>
            </CardHeader.Right>
          )}
        </CardHeader>
        <Card.Name>{trimTextIfNeeded(template.name, 60)}</Card.Name>
        <Card.Date>
          Released: {formatTimestampToDate(template.createdAt, true)}
        </Card.Date>
        <Tooltip title="Opens a new draft using this template">
          <Button onClick={onClick}>
            Use
            <ArrowForwardOutlined style={{ fontSize: '14px' }} />
          </Button>
        </Tooltip>
      </Card.Body>
    </Card>
  );
};

export default TemplateCard;
